import { render, staticRenderFns } from "./EipPostSelector.vue?vue&type=template&id=54c7ec88&"
import script from "./EipPostSelector.vue?vue&type=script&lang=js&"
export * from "./EipPostSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports